/**
 * AuditLogActionBadge Component
 *
 * Color-coded badges for audit log action types and outcomes.
 */

import React from "react";
import type { AuditAction, AuditOutcome } from "../../../types/audit-log.types";

const actionConfig: Record<AuditAction, { label: string; className: string }> = {
  CREATE: { label: "Create", className: "bg-green-100 text-green-800" },
  UPDATE: { label: "Update", className: "bg-blue-100 text-blue-800" },
  DELETE: { label: "Delete", className: "bg-red-100 text-red-800" },
};

const outcomeConfig: Record<AuditOutcome, { label: string; className: string }> = {
  SUCCESS: { label: "Success", className: "bg-green-100 text-green-800" },
  FAILURE: { label: "Failure", className: "bg-red-100 text-red-800" },
};

export const ActionBadge: React.FC<{ action: AuditAction }> = ({ action }) => {
  const config = actionConfig[action] || { label: action, className: "bg-gray-100 text-gray-800" };
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${config.className}`}>
      {config.label}
    </span>
  );
};

export const OutcomeBadge: React.FC<{ outcome: AuditOutcome }> = ({ outcome }) => {
  const config = outcomeConfig[outcome] || { label: outcome, className: "bg-gray-100 text-gray-800" };
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${config.className}`}>
      {config.label}
    </span>
  );
};
